import remove from 'lodash/remove'
import isEmpty from 'lodash/isEmpty'
import compact from 'lodash/compact'

export class MainFilter {
  private filtercategory: any[]
  private filtertype: any[]

  constructor() {
    this.filtercategory = []
    this.filtertype = []
  }

  run = ({ value, name, type }) => {
    // this?.[name]?.(value)
    this.generateOrFilter({ name, value, type })
    return this.generateFilter()
  }

  generateOrFilter = ({ name, value, type }) => {
    if (value) {
      //we use here the regex so we can search also olap_ or pdf_,
      const filterValue = { category: { $options: 'i', $regex: name } }
      this[`filter${type}`].push(filterValue)
    } else {
      this[`filter${type}`] = remove(this?.[`filter${type}`], (item: any) => {
        return item?.category?.$regex?.indexOf(name) === -1
      })
    }
  }

  generateFilter = () => {
    const categoryFilter = !isEmpty(this.filtercategory) ? { $or: this.filtercategory } : null
    const typeFilter = !isEmpty(this.filtertype) ? { $or: this.filtertype } : null
    const finalFilter = compact([categoryFilter, typeFilter])
    if (!isEmpty(finalFilter)) {
      return JSON.stringify({ $and: finalFilter })
    }
  }
}
